import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import { lang } from "../../../i18nLang";

const ButtonFinish = ({ finished, onFinish, onNext, ...props }) => {
  return finished ? (
    <Button {...props} onClick={onFinish}>
      {lang("save")}
    </Button>
  ) : (
    <Button {...props} onClick={onNext}>
      {lang("continue")}
    </Button>
  );
};

const FormModal = ({
  open,
  onClose,
  title,
  children,
  finished,
  disabledButton,
  onNext,
  onFinish,
}) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>{children}</DialogContent>
    <DialogActions>
      <Button color="default" onClick={onClose}>
        {lang("cancel")}
      </Button>
      <ButtonFinish
        color="primary"
        disabled={disabledButton}
        finished={finished}
        onFinish={onFinish}
        onNext={onNext}
      />
    </DialogActions>
  </Dialog>
);

export default FormModal;
